import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { FormikProps } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LanguageAbbreviation } from '../../models/enums/LanguageAbbreviation';
import { INewPerson } from '../../models/interfaces/INewPerson';
import { RootState } from '../../redux';
import styles from './PrivacyPolicyForm.module.scss';

interface IPrivacyPolicyFormProps {
    formik: FormikProps<INewPerson>;
    title?: string;
    getErrorFieldProps: (formik, field) => void | { errorMessage: string };
    getFieldProps: (formik, field) => void | { errorMessage: string };
}

const PrivacyPolicyAcceptedField = 'privacyPolicyAccepted';

const PrivacyPolicyForm = ({ formik, getFieldProps, title }: IPrivacyPolicyFormProps): JSX.Element => {
    const { t } = useTranslation();
    const { language } = useSelector((state: RootState) => state.lang);

    const getPrivacyPolicyLink = (): string => {
        const isPolish = language === LanguageAbbreviation.pl;
        const isCompany = formik.values.isCompany;

        if (isPolish) {
            return isCompany
                ? 'https://www.future-processing.com/pl/polityka-prywatnosci/wspolpracownicy/'
                : 'https://www.future-processing.com/pl/polityka-prywatnosci/pracownicy/';
        } else {
            return isCompany
                ? 'https://www.future-processing.com/privacy-policy/contractors/'
                : 'https://www.future-processing.com/privacy-policy/privacy-policy-employees/';
        }
    };

    React.useEffect(() => {
        console.log('PrivacyPolicyForm mounted');
    }, []);

    return (
        <div className={styles.form}>
            <h2>{title}</h2>
            <div className={styles.linkContainer}>
                <a href={getPrivacyPolicyLink()} target="_blank" rel="noopener noreferrer" className={styles.privacyPolicyLink}>
                    {t('PrivacyPolicyLabels.ReadPrivacyPolicyLink')}
                </a>
            </div>
            <div className={styles.checkoboxField}>
                <Checkbox
                    label={t('PrivacyPolicyLabels.PrivacyPolicyAcceptedCheckbox')}
                    className={styles.requiredCheckbox}
                    required
                    {...getFieldProps(formik, PrivacyPolicyAcceptedField)}
                    checked={formik.values.privacyPolicyAccepted}
                    onChange={() => {
                        formik.setFieldValue(PrivacyPolicyAcceptedField, !formik.values.privacyPolicyAccepted);
                    }}
                />
                {getFieldProps(formik, PrivacyPolicyAcceptedField) && (
                    <div className={styles.errorMessage}>{getFieldProps(formik, PrivacyPolicyAcceptedField)?.errorMessage}</div>
                )}
            </div>
        </div>
    );
};

export default PrivacyPolicyForm;
